import london from '../../assets/OurMission/london and partners 1.png'
import wayra from '../../assets/OurMission/wayrauk 1.png'
import santar from '../../assets/OurMission/santander 1.png'
import barclay from '../../assets/OurMission/barclays incubator 1.png'
import lawTech from '../../assets/OurMission/lawtech-panel-logo 1.png'
const OurPatners = () => {
  return (
    <div
      className='flex flex-col items-start self-stretch gap-5 px-[20px] lg:px-20
         2xl:gap-10 2xl:px-[120px] 3xl:px-[190px]'
    >
      <div className='flex flex-col items-center self-stretch gap-3 2xl:gap-4 '>
        <h2
          className='text-[#192D59] text-lg font-bold leading-6 tracking-wide text-center lg:text-[24px] leading-[32px] lg:tracking-wide 2xl:text-[#65C2D7] 2xl:text-[32px] 2xl:leading-normal
  3xl:text-[40px] 3xl:leading-normal'
        >
          We have been a recognised{' '}
          <span className='text-[#001A3D]'>pioneer.</span>
        </h2>
        <p className='text-[#405985] text-center font-dmSans font-medium text-sm leading-normal lg:text-base lg:leading-6 lg:tracking-wide 3xl:text-lg 3xl:font-bold '>
          Selected to deliver on our mission and share our vision around the
          world.
        </p>
      </div>

      <div className='flex justify-center items-center content-center gap-4 flex-wrap self-stretch  lg:justify-between lg:items-center lg:self-stretch'>
        <img
          src={barclay}
          className='w-[95px] h-[59px] 2xl:w-[139px] 2xl:h-[87px] 3xl:w-[197px] 3xl:h-[124px]'
        />
        <img
          src={santar}
          className='w-[79.474px] h-[38.752px] flex-shrink-0 2xl:w-[117.358px] 2xl:h-[57.224px] 3xl:w-[166.711px] 3xl:h-[81.289px]'
        />

        <img
          src={lawTech}
          className='w-[99px] h-[30px] 2xl:w-[146px] 2xl:h-[43px] 3xl:w-[207px] 3xl:h-[62px]'
        />

        <img
          src={london}
          className='w-[80px] h-[49px] 2xl:w-[118px] 2xl:h-[71px] 3xl:w-[167px] 3xl:h-[100px]'
        />
        <img
          src={wayra}
          className='w-[78px] h-[30px] 2xl:w-[113px] 2xl:h-[45px] 3xl:w-[160px] 3xl:h-[64px]'
        />
      </div>
    </div>
  )
}
export default OurPatners
